import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosKeycloakApi";
import NavBar from "../../components/Navbar/Navbar";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useKeycloak } from "@react-keycloak/web";


const OnderhoudstakenOverzicht = () => {
  const [onderhoudstaken, setOnderhoudstaken] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("current_user_data"));
  const { keycloak, initialized } = useKeycloak();


  const isUserPandInformatiebeheerder = () => {
    let pandInformatiebeheerder = 5;

  //   if (!currentUser.groups.includes(pandInformatiebeheerder)) {
  //     return false;
  //   }
    // return false;
    return true;
  };

  if (!keycloak.authenticated){
    localStorage.setItem("access_token", null)
    window.location = "/app/";
    console.log("user is NOT authenticated, setting null token in local storage");
  };

  const getPanden = async () => {
    try { 
      await axiosInstance.get("onderhoudstaken/").then((response) => {
        setOnderhoudstaken(response.data);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const toonOnderhoudstaken = () => {
    return onderhoudstaken.map((onderhoudstaak, index) => {
      return (
        <tr key={index}>
          <td>{onderhoudstaak.id}</td>
          <td>{onderhoudstaak.omschrijving}</td>
          <td>{`€ ${onderhoudstaak.kosten} p.m.`}</td>
          <td>
            {isUserPandInformatiebeheerder() ? (
              <Link
                className="button is-info is-small is-outlined"
                to={{
                  pathname: `/onderhoudstaken/${onderhoudstaak.id}/edit`,
                  state: { id: onderhoudstaak.id },
                }}
              >
                <i className="far fa-edit"></i>
                <strong>Bewerken</strong>
              </Link>
            ) : (
              <Tooltip
                title="Je hebt niet de juiste bevoegdheden"
                placement="bottom"
              >
                <button
                  className="button is-dark is-small disabled-button"
                  disabled
                >
                  <i className="far fa-edit" />
                  <strong>Bewerken (niet mogelijk)</strong>
                </button>
              </Tooltip>
            )}
          </td>
        </tr>
      );
    });
  };

  useEffect(() => {
    getPanden();
  }, []);

  return (
    <>
      <NavBar />
      <section className="section">
        <div className="container" style={{ width: "75%" }}>
          <h1 className="title is-1">Onderhoudstaken</h1>
          <div className="table-box box">
            {isUserPandInformatiebeheerder() ? (
              <Link
                className="button is-primary is-small is-outlined"
                style={{ marginBottom: "1.5rem" }}
                to="/onderhoudstaken/toevoegen"
              >
                <i className="fas fa-plus-circle"></i>
                <strong>Onderhoudstaak toevoegen</strong>
              </Link>
            ) : (
              <Tooltip
                title="Je hebt niet de juiste bevoegdheden"
                placement="bottom"
              >
                <button
                  className="button is-dark is-small"
                  style={{ marginBottom: "1.5rem" }}
                  disabled
                >
                  <i className="fas fa-plus-circle"></i>
                  <strong>Onderhoudstaak toevoegen (niet mogelijk)</strong>
                </button>
              </Tooltip>
            )}
            <table className="table is-fullwidth is-hoverable">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Omschrijving</th>
                  <th>Kosten</th>
                  <th>Actie</th>
                </tr>
              </thead>
              <tbody>{toonOnderhoudstaken()}</tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};

export default OnderhoudstakenOverzicht;
